import { DropdownMenu } from "../../components/ui/dropdown/dropdown";
import styled, { device, css } from "../../shared/styled";

export const StyledDropMenu = styled(({ ...rest }) => <DropdownMenu {...rest} />)`
  display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
    border-radius: 10px;
    border: none;
    width: 420px;
    max-height: 620px;
    margin-right: -10px;
    right: 0;
    left: auto;
    overflow: hidden;

  ${(props: any) =>
    !props.show &&
    css`
      display: none;
    `}

  ${device.large} {
    margin-top: 18px;
  }

  ${(props) =>
    props.theme.name === "dark" &&
    css`
      background-color: #2d3548;
      border-color: #2d3548;
    `}
`;

StyledDropMenu.displayName = "DropdownMenu";

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px 20px 10px;
    width: 100%;
    border-bottom: 1px solid #DEEBFF80;
        align-items: center;

  ${(props) =>
    props.theme.name === "dark" &&
    css`
      border-bottom-color: rgba(255, 255, 255, 0.14);
    `}
`;

export const HeaderTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const HeaderTitle = styled.h3`
font-family: 'Inter';
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 28px;
color: #091E42;
margin-bottom: 0px;

  ${(props) =>
    props.theme.name === "dark" &&
    css`
      color: #f0f2f5;
    `}
`;

export const HeaderSubtitle = styled.span`
font-family: 'Inter';
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 16px;
color: #42526E;

  ${(props) =>
    props.theme.name === "dark" &&
    css`
      color: #c8d0dc;
    `}
`;

export const HeaderCloseIcon = styled.button`
  border: none;
  background: transparent;
  padding: 4px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  cursor: pointer;

  &:hover {
    background-color: rgba(148, 163, 184, 0.12);
  }

  ${(props) =>
    props.theme.name === "dark" &&
    css`
      color: #c8d0dc;

      & img {
        filter: brightness(0) invert(0.85);
      }

      &:hover {
        background-color: rgba(255, 255, 255, 0.08);
      }
    `}
`;

export const ListWrapper = styled.div`
    width: 100%;
  overflow-y: auto;
`;

export const EmptyState = styled.div`
  padding: 60px 20px 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  .empty-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 8px;
  }

  h3 {
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 28px;
text-align: center;
color: #091E42;
  }

  p {
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
text-align: center;
color: #42526E;
  }

  ${(props) =>
    props.theme.name === "dark" &&
    css`
      h3 {
        color: #f0f2f5;
      }

      p {
        color: #c8d0dc;
      }

      .empty-icon {
        filter: brightness(0) invert(0.88);
        opacity: 0.9;
      }
    `}
`;

export const StyledItem = styled.div`
display: flex;
flex-direction: row;
align-items: flex-start;
padding: 16px 24px;
border-bottom: 1px solid #F4F5F7;
border-radius: 0px;
flex: none;
order: 0;
align-self: stretch;
flex-grow: 0;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f8fafc;
  }

  .content {
    flex: 1;
  }
    h4 {
  font-family: 'Inter';
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
color: #091E42;
    }
  p {
font-family: 'Inter';
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 16px;
color: #42526E;
  }

  .time {
font-family: 'Inter';
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 16px;
color: #5E6C84;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .actions {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
  }

  &:hover .actions {
    opacity: 1;
    pointer-events: auto;
  }

  .unread-dot {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: #4C9AFF;
    margin-top: 4px;
  }

  .mark-read-btn {
font-family: 'Inter';
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 20px;
color: #0065FF;



    background-color: transparent;
    border: none;
    padding: 10px 0;
    cursor: pointer;
 
    white-space: nowrap;
    -webkit-transition: opacity 0.2s;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }
  }

  .delete-btn {
    background-color: transparent;
    border: none;
    padding: 0px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
    transition: color 0.2s;
  }
  .delete-btn img {
    width: 16px;
    height: 16px;
    pointer-events: none;
  }

  &.unread {
 background: rgba(222, 235, 255, 0.5);
     gap: 50px;
     cursor: pointer;
    p {
      font-weight: 500;
    }

    &.unread {

      p {
        font-weight: 500;
      }
    }

    &.read {
      background-color: #ffffff;
     cursor: pointer;
      p {
        font-weight: 400;
        color: #64748b;
      }
    }
    }
  }

  ${(props) =>
    props.theme.name === "dark" &&
    css`
      border-bottom-color: rgba(255, 255, 255, 0.08);

      &:hover {
        background-color: rgba(255, 255, 255, 0.06);
      }

      h4 {
        color: #f0f2f5;
      }

      p {
        color: #c8d0dc;
      }

      .time {
        color: #9aa5b4;
      }

      &.unread {
        background: rgba(107, 163, 255, 0.15);
      }

      &.read {
        background: transparent;
      }
    `}
`;

export const Footer = styled.div`
    box-sizing: border-box;
    display: flex;
    width: 420px;
    height: 62px;
    border-top: 1px solid rgba(222, 235, 255, 0.5);
    border-radius: 0px;
    flex: none;
    order: 2;
    align-self: stretch;
    flex-grow: 0;
    align-items: center;
        justify-content: space-between;
    padding: 0px 15px;

  ${(props) =>
    props.theme.name === "dark" &&
    css`
      border-top-color: rgba(255, 255, 255, 0.14);
    `}
`;

export const MarkAllReadButton = styled.button`
font-family: 'Inter';
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
text-align: center;
color: #0065FF;
background: transparent;
    border: none;
  &:hover {
    text-decoration: none;
  }

  ${(props) =>
    props.theme.name === "dark" &&
    css`
      color: #6ba3ff;
    `}
`;

export const UnreadBadge = styled.div`
  position: absolute;
  top: 1px;
  right: 0px;
  width: 8px;
  height: 8px;
  background-color: #22C55E;
  border-radius: 50%;

`;